import {useKEIConnect} from '@kei.fi/connect';
import {createContext, PropsWithChildren, useContext} from 'react';
import {Balance, Transactions, Transfer} from '@/api-requests/tokens';
import {useFetchAccountData} from '@/providers/account/useFetchAccountData';

export interface AccountStoredState {
  address?: string;
  balances?: Balance[];
  transfers?: Transfer[];
  txs?: Transactions[];
  internalTxs?: Transactions[];
  blockNumber?: number;
}

export interface AccountState extends AccountStoredState {
  isLoading: boolean;
}

export const ALLOWED_CONTRACT_ADDRESSES = [];

export const AccountContext = createContext<AccountState | null>(null);

export const AccountProvider = ({children}: PropsWithChildren) => {
  const {signer} = useKEIConnect();
  const {data = {}, isLoading} = useFetchAccountData();

  return (
    <AccountContext.Provider
      value={{
        ...data,
        address: signer?.address,
        isLoading,
      }}
    >
      {children}
    </AccountContext.Provider>
  );
};

export const useAccountData = () => {
  const context = useContext(AccountContext);

  if (!context) {
    throw new Error('Missing the AccountProvider');
  }

  return context;
};
